export default __webpack_public_path__ + "static/media/gallery_02.fd79e399.jpg";